import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function useSafeRedirect(path, condition) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!condition || !path) return;
    const timer = setTimeout(() => {
      try {
        navigate(path, { replace: true });
      } catch {
        window.location.replace(path);
      }
    }, 0);
    return () => clearTimeout(timer);
  }, [path, condition, navigate]);
}
